import { useRef, useState } from "react";

export function AuthorDialog() {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [showQr, setShowQr] = useState(false);

  function close() {
    dialogRef.current?.close();
    setShowQr(false);
  }

  return <>
    <button className="header-text-button" type="button" onClick={() => dialogRef.current?.showModal()}>关于作者</button>
    <dialog className="author-dialog" ref={dialogRef} onClose={() => setShowQr(false)} onClick={(event) => { if (event.target === dialogRef.current) close(); }} aria-labelledby="author-dialog-title">
      <div className="author-dialog-inner">
        <button className="dialog-close" type="button" onClick={close} aria-label="关闭关于作者弹窗">×</button>
        <span className="eyebrow">本站制作人</span>
        <h2 id="author-dialog-title">你好，我是点点PPK！</h2>
        <p>感谢你来体验我做的人生地图。如果你对这个感兴趣，可以来关注我的抖音，我会非常开心，可以第一时间了解到我后续的项目，我其实还做了很多小玩意儿！我的抖音号是 <strong>91222628056</strong>。</p>
        <p>无论如何都要感谢你，你的到来让我付出的时间有了意义。</p>
        <div className={`qr-reveal${showQr ? " is-open" : ""}`}>
          <button type="button" className="qr-reveal-button" aria-expanded={showQr} aria-controls="author-qr" onClick={() => setShowQr((value) => !value)}>查看抖音二维码</button>
          <div className="qr-popover" id="author-qr"><img src="./author-douyin-qr.png" width="350" height="400" alt="点点PPK的抖音二维码，抖音号 91222628056"/><span>点点PPK · 抖音号 91222628056</span></div>
        </div>
        <p className="author-source-note">点点PPK是本站制作人；原书作者与来源信息见“来源与许可”。</p>
      </div>
    </dialog>
  </>;
}
